import React from 'react';
import { connect } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';
import LowScoreRedirect from './LowScoreRedirect';
import LottieLogo from './LottieLogo';
import config from '../config';
import { IAppState } from '../db/reducers';
import styled from 'styled-components';

const SThanks = styled.div`
  height: 90vh
`

interface IThanksProps {
  currentUserScore: number;
}

const Thanks: React.SFC<IThanksProps> = (props) => {
  const location = useLocation();
  const history = useHistory();

  const { currentUserScore } = props;

  const handleClick = () => {
    const resultsPage = location.pathname.replace('/thanks', '/results');
    history.push(resultsPage);
  };

  return (
    <SThanks className={"Thanks"}>
      <div className={"ThanksHeader"} />
      {0 < currentUserScore && currentUserScore <= 3 && <LowScoreRedirect />}
      <div className={"ThanksLogo"}>
        <LottieLogo height={'40vh'} width={'40vh'} />
      </div>
      <div className={"ThanksEverythingElse"}>
        <div className={"ThanksTextTop"}>
          <p style={{ width: '80vw' }}>Thank you!</p>
        </div>
        <div className={"ThanksBtns"} style={{flexDirection: 'row'}}>
          <button onClick={handleClick}>View Results</button>
        </div>
        <div className={"ThanksTextBottom"}>
          <p style={{ opacity: 0.4 }}>
            ...or find out more about Form
            <a href={config.formscoreUrl} style={{textDecoration: "initial"}}>
              &nbsp;here.
            </a>
          </p>
        </div>
      </div>
    </SThanks>
  );
};

const mapStateToProps = (state: IAppState) => {
  return {
    currentUserScore: state.currentUserScore,
  };
};

export default connect(mapStateToProps)(Thanks);
